import { Box, Button, Typography, Chip } from "@mui/material";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { OrderDetails } from "../types/types";

const safeNumber = (value: any): number => (isNaN(Number(value))) ? 0 : Number(value);

const getFulfillmentBadge = (fulfillmentStatus: string) => {
  const statusMap = {
    unfulfilled: { 
      color: "error" as const, 
      label: "Unfulfilled", 
      icon: <LocalShippingIcon /> 
    },
    partially_fulfilled: { 
      color: "warning" as const, 
      label: "Partially Fulfilled", 
      icon: <LocalShippingIcon /> 
    },
    fulfilled: { 
      color: "success" as const, 
      label: "Fulfilled", 
      icon: <CheckCircleIcon /> 
    }
  };
  
  const status = fulfillmentStatus as keyof typeof statusMap;
  const { color, label, icon } = statusMap[status] || statusMap.unfulfilled;
  
  return (
    <Chip
      icon={icon}
      label={label}
      color={color}
      sx={{ ml: 1 }}
    />
  );
};

export const OrderSummary = ({ 
  orderDetails,
  fulfillmentStatus,
  id,
  isMobile,
  generatePDF 
}: { 
  orderDetails: OrderDetails;
  fulfillmentStatus: string;
  id: string;
  isMobile: boolean;
  generatePDF: () => void 
}) => {
  const total = safeNumber(orderDetails.total);
  const balance = safeNumber(orderDetails.outstanding_balance);

  return (
    <Box mb={3} p={2} bgcolor="primary.main" color="white" borderRadius={2}>
      <Typography variant="h5" gutterBottom>
        Order #{id}
      </Typography>
      <Box display="flex" alignItems="center" mb={1}>
        <Typography variant="body1">
          <strong>Status:</strong> {orderDetails.status || "Pending"}
        </Typography>
        {getFulfillmentBadge(fulfillmentStatus)}
      </Box>
      <Typography variant="body1">
        <strong>Total:</strong> ${total.toFixed(2)}
      </Typography>
      <Typography variant="body1">
        <strong>Balance:</strong> ${balance.toFixed(2)}
      </Typography>
      <Button
        variant="contained"
        color="secondary"
        sx={{ mt: 2 }}
        onClick={generatePDF}
      >
        Download Invoice
      </Button>
    </Box>
  );
};